import React from 'react';
import { connect } from 'react-redux';
import { Segment, Image } from 'semantic-ui-react';
import './SettingsMore.css';
import Strings from '../../common/Strings';
import { version } from '../../../package.json';
import { gitHash } from '../../gitHash.json';

const renderGitHash = () => {
  if (process.env.REACT_APP_ENV === 'dev') {
    return (
      <div>
        <div>
          <h2 className="settings-version-title">Version</h2>
          <p className="settings-version-text">{version}</p>
        </div>

        <div>
          <h4 className="settings-version-title"> Git Hash </h4>
          <p className="settings-version-text">{gitHash}</p>
        </div>
      </div>
    );
  }
  return null;
};

const SettingsMore = () => (
  <div className="more-root">
    <Segment basic className="more-content">
      <h1 id="more-title-text" className="more-title">
        {Strings.SETTINGS.moreiworkie}
      </h1>
      <h1 id="more-support-text" className="more-support-text">
        {Strings.SETTINGS.moreSupport}
      </h1>
      <p id="more-support-info-text" className="more-support-info-text">
        {Strings.SETTINGS.moreSupportInfo}
      </p>
      <a
        id="more-support-email-link"
        href="mailto:support@iworkie.com"
        className="more-support-email-link"
      >
        {Strings.SETTINGS.moreSupportEmail}
      </a>
      <div className="more-icon-container">
        <Image
          id="facebook-icon"
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.facebook.com/iworkie"
          className="more-icon"
          src="/icon/facebook.svg"
          alt="Facebook"
        />
        <Image
          id="twitter-icon"
          target="_blank"
          rel="noopener noreferrer"
          href="https://twitter.com/iworkieapp"
          className="more-icon"
          src="/icon/twitter.svg"
          alt="Twitter"
        />
      </div>
      <div className="more-terms-container">
        <a
          id="more-terms-link"
          className="more-terms-link"
          target="_blank"
          rel="noopener noreferrer"
          href="https://iworkie.com/terms-of-service"
        >
          {Strings.SETTINGS.moreTerms}
        </a>
        <div id="more-terms-divider" />
        <a
          id="more-privacy-link"
          className="more-terms-link"
          target="_blank"
          rel="noopener noreferrer"
          href="https://iworkie.com/privacy-policy"
        >
          {Strings.SETTINGS.morePrivacy}
        </a>
      </div>
      {renderGitHash()}
    </Segment>
  </div>
);

export default connect()(SettingsMore);



// WEBPACK FOOTER //
// ./src/components/settings/SettingsMore.js